import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import ProtectedRoute from "./components/ProtectedRoute";
import LoginPage from "./pages/LoginPage";
import DashboardAdmin from "./pages/DashboardAdmin";
import DashboardDocente from "./pages/DashboardDocente";
import DashboardEstudiante from "./pages/DashboardEstudiante";
import GestionUsuarios from "./pages/GestionUsuarios";
import GestionEstructura from "./pages/GestionEstructura";
import GestionGrupos from "./pages/GestionGrupos";
import ActividadesDocente from "./pages/ActividadesDocente";
import CrearActividad from "./pages/CrearActividad";
import AsignarActividad from "./pages/AsignarActividad";
import ResolverActividad from "./pages/ResolverActividad";
import BandejaRevision from "./pages/BandejaRevision";
import ReportesDocente from "./pages/ReportesDocente";
import { Toaster } from "./components/ui/sonner";

const AppRouter = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      
      <Route 
        path="/admin" 
        element={
          <ProtectedRoute requiredRoles={['admin']}>
            <DashboardAdmin />
          </ProtectedRoute>
        } 
      />
      
      <Route 
        path="/admin/usuarios" 
        element={
          <ProtectedRoute requiredRoles={['admin']}>
            <GestionUsuarios />
          </ProtectedRoute>
        } 
      />
      
      <Route 
        path="/admin/estructura" 
        element={
          <ProtectedRoute requiredRoles={['admin']}>
            <GestionEstructura />
          </ProtectedRoute>
        } 
      />
      
      <Route 
        path="/admin/grupos" 
        element={
          <ProtectedRoute requiredRoles={['admin']}>
            <GestionGrupos />
          </ProtectedRoute>
        } 
      />
      
      <Route 
        path="/admin/revision" 
        element={
          <ProtectedRoute requiredRoles={['admin']}>
            <BandejaRevision />
          </ProtectedRoute>
        } 
      />
      
      <Route 
        path="/docente" 
        element={
          <ProtectedRoute requiredRoles={['docente']}>
            <DashboardDocente />
          </ProtectedRoute>
        } 
      />
      
      <Route 
        path="/docente/actividades" 
        element={
          <ProtectedRoute requiredRoles={['docente']}>
            <ActividadesDocente />
          </ProtectedRoute>
        } 
      />
      
      <Route 
        path="/docente/actividades/nueva" 
        element={
          <ProtectedRoute requiredRoles={['docente']}>
            <CrearActividad />
          </ProtectedRoute>
        } 
      />
      
      <Route 
        path="/docente/actividades/:actividadId/asignar" 
        element={
          <ProtectedRoute requiredRoles={['docente']}>
            <AsignarActividad />
          </ProtectedRoute>
        } 
      />
      
      <Route 
        path="/docente/resultados" 
        element={
          <ProtectedRoute requiredRoles={['docente']}>
            <ReportesDocente />
          </ProtectedRoute>
        } 
      />
      
      <Route 
        path="/estudiante" 
        element={
          <ProtectedRoute requiredRoles={['estudiante']}>
            <DashboardEstudiante />
          </ProtectedRoute>
        } 
      />
      
      <Route 
        path="/estudiante/actividad/:actividadId/:asignacionId" 
        element={
          <ProtectedRoute requiredRoles={['estudiante']}>
            <ResolverActividad />
          </ProtectedRoute>
        } 
      />
      
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
};

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
